import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { RowClassArgs, SelectionEvent } from '@progress/kendo-angular-grid';
import { JobPlanSearchService } from 'src/app/features/acd/service/job-plan-search.service';
import { EMDMICONS } from 'src/app/features/common/constants/icon-pack.constant';
import { commonService } from 'src/app/services/common.service';
import { eplService } from 'src/app/services/epl.service';
import { ExportService } from 'src/app/services/export.service';
import { mwoService } from 'src/app/services/mwo.service';
import { PMService } from '../../service/pm.service';
import { ColumnConfig } from 'src/app/features/common/models/column-config.model';

@Component({
  selector: 'app-acd-search',
  templateUrl: './acd-search.component.html',
  styleUrl: './acd-search.component.scss'
})
export class AcdSearchComponent {

  searchType = "";
  crNo = 0;
  isCombine = true;
  mwoErrorTextList: any = [];


  @Input() set setCRNo(crNo: number) {
    if (crNo > 0) {
      this.crNo = crNo
    }
  }

  @Output() stepNavigateTo = new EventEmitter<string>();

  isMWOShow = false;
  isMWOProbDescShow = false;
  isJPNumberShow = false;
  isActivePMWOShow = false;
  isMWIShow = false;
  isEPLShow = false;
  btnActionName = '';
  isSearchPerformed = false;
  ispopupopened = false;

  @Input() set buildType(buildType: string) {
    if (buildType) {
      this.searchType = buildType;
      this.searchFieldShowHide();
      this.btnActionName = buildType == 'JobPlan' ? 'Job Plan' : buildType;
    }
  }

  buildTypeList = ['JobPlan', 'MWO', 'PM', 'EPL'];
  isUserCanAccessRequest = true;
  anchorElement: any;
  textboxElement: any;
  formControlSelected: any;
  remainingCharacter: number = 3500;
  maxlength: number = 3500;
  charachtersCount: number = 0;
  counter = 3500;
  showBulkSearchPopup = false;
  gridHeight: number = 75;
  searchItem: any;

  searchForm: FormGroup = new FormGroup({
    tag: new FormControl(''),
    mwo: new FormControl(''),
    mwoProblemDescription: new FormControl(''),
    jobPlanNumber: new FormControl(''),
    activePMWO: new FormControl(''),
    mwi: new FormControl(''),
    epL_Long: new FormControl(''),
    epl: new FormControl(''),
    item: new FormControl(''),
  });

  subSearchForm = new FormGroup({
    isExactResultsOnly: new FormControl(false)
  });

  epl_JpRadioBtnUpdate = new FormGroup({
    isCombined: new FormControl(true)
  });

  searchData: any[] = [];
  searchExportData: any[] = [];
  public popupResult = [];
  public selectedIds: Set<number> = new Set<number>();
  public obseluteIds: Set<number> = new Set<number>();
  date = new Date();
  newDate = this.date.toLocaleDateString('en-GB').split('/').reverse().join('') + this.date.toLocaleTimeString('en-GB', { hour12: false }).split(':').join('');
  cr!: object;
  popupShow = false;
  popupTitle = "Show Obselute Items";
  popupHeight = 600;
  popupWidth = 800;

  //payload input for child components
  jobPlanSearchPayload: any = null;

  @HostListener('document:keydown.escape', ['$event1']) handleEscapeEvent(event: KeyboardEvent) {
    this.closePopup();
  }
  iconPack = EMDMICONS;

  isSearchClicked = false;

  selectedIndexIds: number[] = [];

  isShowPagination: boolean = false;
  isSearchedByEplItem: boolean = false;

  showAddEplBtn: boolean = false;
  showUpdateEplBtn: boolean = false;

  constructor(private router: Router, private commonService: commonService, private mwoService: mwoService,
    private eplService: eplService, private exportService: ExportService, private jobPlanService: JobPlanSearchService,
    private pmService: PMService, private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.setSearchData();
  }

  setSearchData() {
    this.formReset();
    if (this.searchType == 'JobPlan' && sessionStorage.getItem('JPsearchData') != '') {
      this.searchForm.patchValue(JSON.parse(sessionStorage.getItem('JPsearchData') || '{}'));
    } else if (this.searchType == 'MWO' && sessionStorage.getItem('MWOsearchData') != '') {
      this.searchForm.patchValue(JSON.parse(sessionStorage.getItem('MWOsearchData') || '{}'));
    } else if (this.searchType == 'PM' && sessionStorage.getItem('PMsearchData') != '') {
      this.searchForm.patchValue(JSON.parse(sessionStorage.getItem('PMsearchData') || '{}'));
    }
    else if (this.searchType == 'EPL' && sessionStorage.getItem('EPLsearchData') != '') {
      this.searchForm.patchValue(JSON.parse(sessionStorage.getItem('EPLsearchData') || '{}'));
    }
  }

  checkForUserAccess() {

  }

  //#region Common Functionality
  searchTypeChanged(searchType: string) {
    this.searchType = searchType;
    this.searchData = [];
    this.adjustGridHeight(this.searchData);
    this.searchExportData = [];
    this.isShowPagination = false;
    this.searchFieldShowHide();
    this.commonService.updateQueryParams('buildType', searchType);
    this.setSearchData();
    this.mwoInputError = false;
    this.eplInputError = false;
    this.jpInputError = false;
    this.activepmInputError = false;
  }

  closeActionPopup(event: any) {
    this.popupTitle = "";
    this.popupShow = false;
  }

  searchFieldShowHide() {
    this.isMWOShow = this.searchType == 'JobPlan' || this.searchType == 'MWO' || this.searchType == 'PM';
    this.isMWOProbDescShow = this.isMWOShow;
    this.isJPNumberShow = this.searchType == 'JobPlan' || this.searchType == 'MWO';
    this.isActivePMWOShow = this.isJPNumberShow;
    this.isMWIShow = this.searchType == 'JobPlan';
    this.isEPLShow = this.searchType == 'EPL'
  }

  public resetClicked() {
    this.formReset()
    this.searchData = [];
    this.adjustGridHeight(this.searchData);
    this.isSearchClicked = false;
    this.selectedIds.clear();
    this.selectedIndexIds = [];
    this.isShowPagination = false;
    this.mwoInputError = false;
    this.eplInputError = false;
    this.jpInputError = false;
    this.activepmInputError = false;
    if (this.searchType == 'JobPlan') {
      sessionStorage.setItem('JPsearchData', '');
    } else if (this.searchType == 'MWO') {
      sessionStorage.setItem('MWOsearchData', '');
    } else if (this.searchType == 'PM') {
      sessionStorage.setItem('PMsearchData', '');
    }
    else if (this.searchType == 'EPL') {
      sessionStorage.setItem('EPLsearchData', '');
    }
  }

  public formReset() {
    this.searchForm = new FormGroup({
      tag: new FormControl(''),
      mwo: new FormControl(''),
      mwoProblemDescription: new FormControl(''),
      jobPlanNumber: new FormControl(''),
      activePMWO: new FormControl(''),
      mwi: new FormControl(''),
      epL_Long: new FormControl(''),
      epl: new FormControl(''),
      item: new FormControl(''),
    });
  }

  isDataChanged() {
    const controls = this.searchForm.controls;
    for (let controlNames in controls) {
      if (controls[controlNames].value != "") {
        return false;
      }
    }
    return true;
  }


  OnKeyDown(event: any) {
    if (event.key === 'Enter') {
      this.search();
    }
  }

  checkAllNumbers(data: any) {
    let elements = data.split(',');
    let allNumbers = elements.every((element: any) => !isNaN(element.trim()));
    return allNumbers;
  }
  mwoInputError: boolean = false;
  eplInputError: boolean = false;
  jpInputError: boolean = false;
  activepmInputError: boolean = false;
  checkValidNumericValues() {
    let flag = true;
    if (this.searchType == 'JobPlan' || this.searchType == 'MWO') {
      flag = !this.checkAllNumbers(this.searchForm.controls["mwo"].value) || !this.checkAllNumbers(this.searchForm.controls["activePMWO"].value);
      this.mwoInputError = !this.checkAllNumbers(this.searchForm.controls["mwo"].value);
      this.activepmInputError = !this.checkAllNumbers(this.searchForm.controls["activePMWO"].value);
    } else if (this.searchType == 'PM') {
      flag = !this.checkAllNumbers(this.searchForm.controls["mwo"].value);
      this.mwoInputError = !this.checkAllNumbers(this.searchForm.controls["mwo"].value);
    } else if (this.searchType == 'EPL') {
      flag = !this.checkAllNumbers(this.searchForm.controls["epl"].value);
      this.eplInputError = !this.checkAllNumbers(this.searchForm.controls["epl"].value);
    }

    return flag;
  }

  resetErrorFlags() {
    this.mwoInputError = false;
    this.eplInputError = false;
    this.jpInputError = false;
    this.activepmInputError = false;
  }

  search() {
    this.resetErrorFlags();
    this.selectedIds.clear();
    this.selectedIndexIds = [];
    this.searchData = [];
    this.adjustGridHeight(this.searchData);
    this.isShowPagination = false;
    this.isSearchedByEplItem = false;
    this.mwoErrorTextList = [];
    if (this.isDataChanged()) {
      this.commonService.showNotificationMessage("No search criteria selected", "warning", "center");
    }
    else {
      this.isSearchClicked = true;
      if (!this.checkValidNumericValues()) {
        if (this.searchType == 'JobPlan') {
          this.getJopPlanResults();
          sessionStorage.setItem('JPsearchData', this.setJpData());
        }
        else if (this.searchType == 'MWO') {
          this.getMWOResults();
          sessionStorage.setItem('MWOsearchData', this.setMwoData());
        }
        else if (this.searchType == 'PM') {
          this.getPMResults();
          sessionStorage.setItem('PMsearchData', this.setPMData());
        }
        else if (this.searchType == 'EPL') {
          this.getEPLResults();
          sessionStorage.setItem('EPLsearchData', this.setEPLData());
        }
      }
      else {
        this.commonService.showNotificationMessage('Invalid search criteria: Numeric or comma separated numeric values only', "error", "center");
      }
    }
  }

  setJpData() {
    return JSON.stringify({
      tag: this.searchForm.controls['tag'].value,
      mwo: this.searchForm.controls['mwo'].value,
      mwoProblemDescription: this.searchForm.controls['mwoProblemDescription'].value,
      jobPlanNumber: this.searchForm.controls['jobPlanNumber'].value,
      activePMWO: this.searchForm.controls['activePMWO'].value,
      mwi: this.searchForm.controls['mwi'].value
    }
    )
  }

  setMwoData() {
    return JSON.stringify({
      tag: this.searchForm.controls['tag'].value,
      mwo: this.searchForm.controls['mwo'].value,
      mwoProblemDescription: this.searchForm.controls['mwoProblemDescription'].value,
      jobPlanNumber: this.searchForm.controls['jobPlanNumber'].value,
      activePMWO: this.searchForm.controls['activePMWO'].value,
    })
  }

  setPMData() {
    return JSON.stringify({
      tag: this.searchForm.controls['tag'].value,
      mwo: this.searchForm.controls['mwo'].value,
      mwoProblemDescription: this.searchForm.controls['mwoProblemDescription'].value

    })
  }

  setEPLData() {
    const rawValue = this.searchForm.controls['tag'].value;

    if (rawValue.includes(', ')) {
      const trimmedValue = rawValue
        .split(',')
        .map((part: any) => part.trim())
        .join(',');
      this.searchForm.controls['tag'].setValue(trimmedValue);
    }
    return JSON.stringify({
      
      tag: this.searchForm.controls['tag'].value,
      epl: this.searchForm.controls['epl'].value,
      item: this.searchForm.controls['item'].value,
      eplLong: this.searchForm.controls['epL_Long'].value
    })
  }

  public openPopupCheck(anchor: HTMLElement, textbox: any, formControlSelected: any): void {
    this.anchorElement = anchor;
    this.textboxElement = textbox;
    this.showBulkSearchPopup = !this.showBulkSearchPopup;
    this.formControlSelected = formControlSelected;
  }

  isGridPopupOpened: boolean = false;
  openedGridType: string = "";
  columnConfig: ColumnConfig[] = [];
  gridPopupData: any[] = [];

  eplDetailsColumnConfig: any[] = [
    { field: "item_long", title: "Item", width: 100 },
    { field: "ItemDesc", title: "Description", width: 200 },
    { field: "line_Number_Cpnb", title: "CPNB", width: 60 },
    { field: "item_Qnty", title: "Quantity", width: 60 },
    { field: "item_Sub", title: "Sub Item", width: 90 },
    { field: "SubItemDesc", title: "Sub Item Description", width: 200 },
    { field: "item_Sub_Cpnb", title: "Sub CPNB", width: 60 },
    { field: "item_Sub_Qnty", title: "Sub Quantity", width: 80 }
  ];

  jpStepsColumnConfig: ColumnConfig[] = [
    { field: "operationSequence", title: "Operation Sequence", width: 100 },
    { field: "description", title: "Description", width: 100 },
    { field: "performanceStandard", title: "Performance Standard", width: 120 },
    { field: "craft", title: "Craft", width: 100 },
    { field: "duration", title: "Duration", width: 100 },
    { field: "crewSize", title: "Crew Size", width: 100 },
    { field: "unitOfMeasure", title: "Unit Of Measure", width: 100 },
    { field: "icY_N", title: "IC Y/N", width: 100 },
    { field: "percentageOverlap", title: "Percentage Overlap", width: 100 }
  ];

  jpDetailsColumnConfig: ColumnConfig[] = [

    { field: "itemNumber", title: "Item Number", width: 100 },
    { field: "itemDescription", title: "Item Description", width: 100 },
    { field: "lineNumber", title: "Line Number", width: 100 },
    { field: "quantity", title: "Quantity", width: 100 },
    { field: "unitOfMeasure", title: "Unit of Measure", width: 100 },
    { field: "operationSequence", title: "Operation Sequence", width: 100 }
  ];

  openGridPopup(gridType: string, dataItem: any) {
    this.openedGridType = gridType;
    if (this.openedGridType == "jp-parts") {
      this.popupTitle = "Job Parts for " + dataItem.jobPlanNumber;
      this.popupWidth = 1000;
      this.popupHeight = 500;
      this.columnConfig = this.jpDetailsColumnConfig;
      // this.isGridPopupOpened = true;
      this.viewPartsPopup(dataItem);
    }
    else if (this.openedGridType == "jp-steps") {
      this.popupTitle = "Job Plan Steps for " + dataItem.jobPlanNumber;
      this.popupWidth = 1200;
      this.popupHeight = 500;
      this.columnConfig = this.jpStepsColumnConfig;
      // this.isGridPopupOpened = true;
      this.viewStepsPopup(dataItem);
    }
    else if (this.openedGridType == "epl-details") {
      this.popupTitle = "";
      this.popupWidth = 1200;
      this.popupHeight = 450;
      this.columnConfig = this.eplDetailsColumnConfig;
      this.detailsPopupOpen(dataItem);
    }
    else if (this.openedGridType == "DeleteEpl") {
      this.popupTitle = "Delete obsolete items";
      this.popupWidth = 500;
      this.popupHeight = 300;
      this.popupShow = true;
    }


  }

  closeGridPopup() {
    this.detailsInput = null;
    this.columnConfig = [];
    this.gridPopupData = [];
    this.openedGridType = "";
    this.isGridPopupOpened = false;
  }

  //excel download functionality
  public export(): void {
    if (this.searchData.length === 0) {
      this.commonService.showNotificationMessage("No data to export. Please enter a search criteria.", "info", "center");
    } else {
      let excelFileCustomName = `Export_Search_${this.searchType}_CR${this.crNo}_${this.newDate}`;

      let excelHeaders = this.searchType == 'JobPlan' ? this.excelHeaders_JobPlan :
        this.searchType == 'MWO' ? this.excelHeaders_MWO :
          this.searchType == 'PM' ? this.excelHeaders_PM :
            this.searchType == 'EPL' ? this.excelHeaders_EPL : [];

      if (excelHeaders.length > 0) {
        this.exportService.exportExcel(this.searchExportData, [excelHeaders], excelFileCustomName);
        this.commonService.showNotificationMessage(
          'file downloaded successfully',
          'success',
          'center'
        );
      }
    }
  }

  public OnSelectionChangeEvent(event: SelectionEvent, gridName: string): void {
    if (gridName == 'mainGrid') {
      if (this.searchType == 'EPL') {
        this.selectedIds = this.commonService.onGridSelection(this.selectedIds, event);
      } else {
        this.selectedIds = this.commonService.onGridSelection(this.selectedIds, event);
      }
    }
    else if (gridName == 'obseluteGrid')
      this.commonService.onGridSelection(this.obseluteIds, event);
  }

  createCopyUpdate(event: any, actionType: string) {
    if (this.searchType == 'JobPlan') {
      if (actionType === 'create') {
        this.createNewJobPlan(event);
      }
      else if (actionType === 'copy') {
        this.copyaboveJobPlan(event);
      }
      else if (actionType === 'update') {
        // this.updateJobPlan(event);
        this.checkMwoNumberExists(event)
      }
    }
    else if (this.searchType == 'MWO') {
      if (actionType === 'create') {
        this.createNewMwo(event);
      }
      else if (actionType === 'copy') {
        this.copyAboveMwo();
      }
      else if (actionType === 'update') {
        this.updateMwo();
      }
    }
    else if (this.searchType == 'PM') {
      if (actionType === 'create') {
        this.createNewPM();
      }
      else if (actionType === 'copy') {
        this.copyAbovePM();
      }
      else if (actionType === 'update') {
        this.updatePm();
      }
    }
    else if (this.searchType == 'EPL') {
      if (actionType === 'update') {
        this.updateEPL();
      }
      else if (actionType === 'add') {
        this.addEpl();
      }
    }
  }

  backBTNClicked() {
    this.stepNavigateTo.emit('Define');
  }

  //#endregion Common Functionality

  //#region JobPlan
  popuptitle = "";

  jobPlanPartsData: any = [];
  jobPlanStepsData: any = [];

  excelHeaders_JobPlan = ["Tag", "Job Plan Number", "MWO", "MWO Description"];
  inputValue: string = "";

  trimPayload() {
    const payload = this.searchForm.value;
    for (const key in payload) {
      if (payload[key] && typeof payload[key] === 'string') {
        payload[key] = payload[key].split(',').map((item: any) => item.trim()).join(',');
      }
    }
    return payload;
  }

  getJopPlanResults() {
    let payload = this.trimPayload();

    payload.isExactResultsOnly = this.subSearchForm.controls["isExactResultsOnly"].value ?? false;

    this.jobPlanService.getJobPlanSearchDetails(payload).subscribe((data) => {
      if (data?.length > 0) {
        this.searchData = data;
        this.adjustGridHeight(this.searchData);
        this.isShowPagination = this.searchData.length > 300;
        this.prevJobPlanSearchPayload = payload;
        // jobplan
        this.eplTagList = this.searchForm.controls['tag'].value.split(',').filter((data: any) => data);
        this.searchMWOList = this.searchForm.controls['mwo'].value.split(',').filter((data: any) => data);
        this.searchJobPlanNumberList = this.searchForm.controls['jobPlanNumber'].value.split(',').filter((data: any) => data);
        this.searchMwoProblemDescriptionList = this.searchForm.controls['mwoProblemDescription'].value.split(',').filter((data: any) => data);

        let grey_class = false;
        data.map((response: any, index: number) => {
          const cgrey_class = grey_class;
          // response.isTagSearchMatch = (response?.tag ?? "") == (this.searchForm.controls['tag'].value ?? "");
          // response.isEplShortSearchMatch = (response?.epL_Short_PLITM ?? "") == (this.searchForm.controls['epl']?.value ?? "");
          // response.isEplLongSearchMatch = (response?.epL_Long_PLLITM ?? "") == (this.searchForm.controls['epL_Long']?.value ?? "");

          response.isTagSearchMatch = this.eplTagList.includes(response?.equipTagNumber ?? "");
          response.isMWOSearchMatch = this.searchMWOList.includes(String(response?.mwoNumber) ?? "");
          response.isJobPlanNumberSearchMatch = this.searchJobPlanNumberList.includes(response?.jobPlanNumber ?? "");
          response.isMwoProblemDescriptionSearchMatch = this.searchMwoProblemDescriptionList.includes(response?.mwoProblemDescription ?? "");

          response.hide_view = (index == 0 || data[index - 1].jobPlanNumber !== response.jobPlanNumber) ? response.jobPlanNumber : ''
          response.grey_class = (index == 0 || data[index - 1].jobPlanNumber !== response.jobPlanNumber) ? cgrey_class : !cgrey_class
          if (index == 0 || data[index - 1].jobPlanNumber !== response.jobPlanNumber)
            grey_class = !cgrey_class
        });

        this.searchExportData = data.map((x: any) => {
          return {
            tag: x.equipTagNumber,
            jobPlanNumber: x.jobPlanNumber,
            mwoNumber: x.mwoNumber,
            mwoProblemDescription: x.mwoProblemDescription
          }
        });
      }
    });
  }

  createNewJobPlan(event: Event) {
    event.preventDefault();
    let payload = {
      crid: this.crNo
    }

    this.jobPlanService.createNewJobplan(payload).subscribe((data) => {
      if (data === "Success") {
        this.commonService.showNotificationMessage(
          "New Job plan created.", "success", "center"
        );
        this.commonService.updateQueryParams('step', 'Build');
      } else {
        this.commonService.showNotificationMessage(data, "error", "center");
      }
    }, error => {
      this.commonService.showNotificationMessage('Error while create new jobplan', "error", "center");

    })
  }

  copyaboveJobPlan(event: Event) {
    event.preventDefault();
    if (this.selectedIds.size === 0) {
      this.commonService.showNotificationMessage("Please select at least one JobPlan", "error", "center");
    } else {

      let jobplanlist: Array<number> = [];
      let mwosidlist: Array<number> = [];

      this.selectedIds.forEach((index: any) => {
        jobplanlist.push(this.searchData[index]?.jobPlanNumber ?? "");
        mwosidlist.push(this.searchData[index]?.mwoNumber ?? "");
      });

      let body = {
        crid: this.crNo,
        jobPlanNumbers: jobplanlist.join(','),
        mwos: mwosidlist.join(','),
        // isCombine: this.isCombine
      }
      this.jobPlanService.copyJobplan(body).subscribe((data) => {
        if (data === "Success") {
          this.commonService.showNotificationMessage(
            "Job Plan copied successfully.", "success", "center"
          );
          this.commonService.updateQueryParams('step', 'Build');
        } else {
          this.commonService.showNotificationMessage(data, "error", "center");
        }
      }, error => {
        this.commonService.showNotificationMessage('Error while copy jobplan', "error", "center");

      })
    }
  }

  updateJobPlan(event: Event) {
    event.preventDefault();
    if (this.selectedIds.size === 0) {
      this.commonService.showNotificationMessage("Please select at least one entry", "error", "center");
    } else {

      let jobplanlist: Array<number> = [];
      let mwosidlist: Array<number> = [];

      this.selectedIds.forEach((index: any) => {
        jobplanlist.push(this.searchData[index]?.jobPlanNumber ?? "");
        mwosidlist.push(this.searchData[index]?.mwoNumber ?? "");
      });

      let payloadData = JSON.parse(JSON.stringify(this.searchData));
      let selectCount = 0;
      payloadData.forEach((x: any, index: any) => {
        if (this.selectedIds.has(index)) {
          x.isSelected = true;
          selectCount++;
        } else {
          x.isSelected = false;
        }
      });

      let body = {
        crid: this.crNo,
        jobPlanNumbers: jobplanlist.join(','),
        mwos: mwosidlist.join(','),
        isCombine: this.isCombine,
        searchPayload: this.prevJobPlanSearchPayload,
        searchResult: payloadData,
        selectedAll: this.searchData.length == selectCount ? true : false
      };

      this.jobPlanService.upadteJobplan(body)
        .subscribe((data) => {

          if (data === "Success") {
            this.commonService.showNotificationMessage("Job Plan updated with new jobPlan.", "success", "center");
            this.commonService.updateQueryParams('step', 'Build');
          } else {

            let messageSplit = String(data).split(':');
            if (messageSplit.length == 2 && messageSplit[0] == 'DUPLICATE') {
              this.commonService.showNotificationMessage(messageSplit[1], "warning", "center");
              this.commonService.updateQueryParams('step', 'Build');
            } else {
              this.commonService.showNotificationMessage(data || 'Error in update jobplan', "error", "center");
            }
          }
        }, error => {
          this.commonService.showNotificationMessage('Error in update jobplan', "error", "center");

        })
    }
  }

  viewStepsPopup(dataitem: any) {
    this.jobPlanService.getJobPlanViewSTeps(dataitem.jobPlanNumber).subscribe((data) => {
      this.gridPopupData = []
      if (data?.length > 0) {
        this.gridPopupData = data;
      }
      this.isGridPopupOpened = true;

    });
  }

  viewPartsPopup(dataitem: any) {
    this.jobPlanService.getJobPlanPartsSTeps(dataitem.jobPlanNumber).subscribe((data) => {
      this.gridPopupData = [];

      if (data?.length > 0) {
        this.gridPopupData = data;
      }
      this.isGridPopupOpened = true;
    });
  }

  onValueChange(ev: string) {
    this.inputValue = ev;
    this.charachtersCount = ev.length;
    this.remainingCharacter = this.maxlength - this.charachtersCount;
    this.counter = this.remainingCharacter;
  }

  public popupSubmit() {
    const output = this.inputValue.replace(/\n/g, ',');
    const withoutEmptyLines = this.inputValue.split('\n').filter(line => line.trim() !== '').join('\n');
    const commaSeparatedData = withoutEmptyLines.split('\n').join(',');
    this.textboxElement.value = output;
    this.searchForm.controls[this.formControlSelected].setValue(commaSeparatedData);
    this.showBulkSearchPopup = false;
    this.inputValue = "";
    this.counter = 3500;
  }

  closePopup(): void {
    this.showBulkSearchPopup = false;
    this.inputValue = "";
    this.popuptitle = "";
    this.showDeletePopup = false;
    this.showDeleteReplacePopup = false;
    this.showObselutePopup = false;
    this.eplObseluteData = [];
    this.obseluteIds.clear();
    this.deleteTextboxValue = 0;
    this.deleteTextBox = ""
    this.gridPopupData = [];
    this.showDetailsPopup = false;
    this.deleteReplaceGridData = [];
    this.dataFormInitialize();
    this.validItemAdded = false;
    this.deleteSearchFound = false;
    this.counter = 3500;
  }

  //#endregion JobPlan

  //#region MWO

  excelHeaders_MWO = ["Tag", "Job Plan Number", "MWO", "MWO Description"];
  getMWOResults() {
    let payload = this.trimPayload();
    this.mwoService.getMwoSearch(payload).subscribe((response) => {
      if (response?.length > 0) {
        this.searchData = response;
        this.adjustGridHeight(this.searchData);
        this.isShowPagination = this.searchData.length > 300;

        this.searchExportData = response.map((x: any) => {
          return {
            equipmentTagNumber: x.equipTagNumber,
            jobPlanNumber: x.jobPlanNumber,
            mwo: x.mwoNumber,
            mwoProblem: x.mwoProblemDescription
          }
        });
      }
    });
  }

  createNewMwo(event: Event) {
    event?.preventDefault();
    let reqData = {
      crid: this.crNo
    };

    this.mwoService.createNewMwo(reqData).subscribe((data) => {
      if (data === "Success") {
        this.commonService.showNotificationMessage(
          "Build updated with new MWO Header Change.", "success", "center"
        );


        this.commonService.updateQueryParams('step', 'Build');
      }
    });
  }

  copyAboveMwo() {
    if (this.selectedIds.size === 0) {
      this.commonService.showNotificationMessage("Please select at least one MWO", "error", "center");
    } else {
      //code for create mwo

      let ids: Array<number> = [];
      this.selectedIds.forEach((index: any) => {
        ids.push(this.searchData[index]?.jde_WomId ?? 0);
      });

      let reqdata = {
        crid: this.crNo,
        jde_womId: ids.join(',')
      };

      this.mwoService.copyAboveMwo(reqdata).subscribe((data) => {
        if (data === "Success") {
          this.commonService.showNotificationMessage(
            "Selected records have been copied to the Build screen.", "success", "center"
          );
        } else {
          this.commonService.showNotificationMessage(
            data, "warning", "center", 200, false
          );
        }

        this.commonService.updateQueryParams('step', 'Build');
      });
    }
  }

  updateMwo() {
    if (this.selectedIds.size === 0) {
      this.commonService.showNotificationMessage("Please select at least one MWO", "error", "center");
    } else {
      //code for update mwo
      let ids: Array<number> = [];
      this.selectedIds.forEach((index: any) => {
        ids.push(this.searchData[index]?.jde_WomId ?? 0);
      });

      let reqdata = {
        crid: this.crNo,
        jde_womId: ids.join(',')
      };

      this.mwoService.updateMwo(reqdata).subscribe((data) => {
        if (data === "Success") {
          this.commonService.showNotificationMessage(
            "Build updated with new MWO Header Change", "success", "center"
          );
        } else {
          this.commonService.showNotificationMessage(
            data, "warning", "center", 200, false
          );
        }

        this.commonService.updateQueryParams('step', 'Build');
      });
    }
  }
  //#endregion MWO

  //#region PM
  excelHeaders_PM = ["Tag Header", "MWO", "MWO Description", "Header Route", "Frequency", "Service Type"];

  getPMResults() {
    let payload = this.trimPayload();
    this.pmService.getPmSearch(payload).subscribe((data: any) => {
      if (data) {
        this.searchData = data;
        this.adjustGridHeight(this.searchData);
        this.isShowPagination = this.searchData.length > 300;

        this.searchExportData = data.map((x: any) => {
          return {
            equipmentTagNumber: x.equipmentTagNumberHeader,
            mwo: x.mwo,
            mwoProblem: x.mwoProblemDescription,
            headerRoute: x.headerRoute,
            frequency: x.frequency,
            serviceType: x.serviceType
          }
        });
      }
    });
  }

  createNewPM() {
    this.pmService.createPMBuild(this.crNo).subscribe((response: any) => {
      if (response && response.warningMessage == null && response.errorMessage == null) {
        this.commonService.showNotificationMessage(
          "Build updated with new PM Change.", "success", "center", 200 , false
        );
      }

      this.commonService.updateQueryParams('step', 'Build');
    });
  }

  copyAbovePM() {
    if (this.selectedIds.size === 0) {
      this.commonService.showNotificationMessage("Please select at least one PM", "error", "center");
    } else {
      let selectedData: any[] = [];
      this.selectedIds.forEach((index: any) => {
        selectedData.push(this.searchData[index]);
      });

      this.pmService.copyPMBuild(this.crNo, selectedData).subscribe((response: any) => {
        if (response.errorMessage) {
          let x = response.errorMessage;
          this.commonService.showNotificationMessage(x, 'error', 'center', 200, false);
        }
        else
          if (response.warningMessage) {
            let x = response.warningMessage;
            this.commonService.showNotificationMessage(x, 'warning', 'center', 200, false);
            this.commonService.updateQueryParams('step', 'Build');

          } else {
            this.commonService.showNotificationMessage(
              "Build updated with new PM Change.", "success", "center", 200, false
            );
            this.commonService.updateQueryParams('step', 'Build');
          }

      });
    }
  }

  updatePm() {
    if (this.selectedIds.size === 0) {
      this.commonService.showNotificationMessage("Please select at least one PM", "error", "center");
    } else {
      let selectedData: any[] = [];
      this.selectedIds.forEach((index: any) => {
        selectedData.push(this.searchData[index]);
      });

      this.pmService.updatePMBuild(this.crNo, selectedData).subscribe((response: any) => {
        if (response) {
          if (response.errorMessage) {
            let x = response.errorMessage;
            this.commonService.showNotificationMessage(x, 'error', 'center', 200, false);
          }
          else
            if (response.warningMessage) {
              let x = response.warningMessage;
              this.commonService.showNotificationMessage(x, 'warning', 'center', 200, false);
              this.commonService.updateQueryParams('step', 'Build');

            } else {
              this.commonService.showNotificationMessage("Build updated with new PM Change.", "success", "center", 200, false);

              this.commonService.updateQueryParams('step', 'Build');
            }
        }
      });
    }
  }
  //#endregion PM

  //#region EPL

  validateEPL() {
    let tagValue = this.searchForm.get('tag')?.value;
    if (tagValue) {
      this.eplService.validateEpl(this.crNo, tagValue).subscribe({
        next: (response: any) => {
          if (response.toLocaleLowerCase() == "add new epl") {
            this.addEpl();
          }
        },
        error: (err: any) => {
          if (err?.message) {
            this.commonService.showNotificationMessage(err?.message, 'warning', 'center');
          }
        }
      });
    }
  }

  addEpl() {
    let tagValue = this.searchForm.get('tag')?.value;
    this.eplService.addEpl(this.crNo, tagValue).subscribe({
      next: (response: any) => {
        this.commonService.showNotificationMessage("Build updated with new EPL Change.", "success", "center");
        this.stepNavigateTo.emit('Build');
      },
      error: (err: any) => {
        if (err?.message) {
          this.commonService.showNotificationMessage(err?.message, 'warning', 'center');
        }
      }
    });
  }

  updateEPL() {
    if (this.selectedIds.size > 0) {
      let isCombined = this.epl_JpRadioBtnUpdate.get('isCombined')?.value;

      let payloadData = JSON.parse(JSON.stringify(this.searchData));

      if (payloadData.length > 0) {

        payloadData.forEach((x: any, index: any) => {
          if (this.selectedIds.has(index)) {
            x.isSelected = true;
          }
        });

        let updatedPayload = {
          EPLSearchResponsesData: payloadData,
          searchRequest: this.prevEplSearchPayload
        }

        this.eplService.updateEpl(this.crNo, isCombined, updatedPayload).subscribe({
          next: (response: any) => {
            if (response != null && response.data.length > 0) {
              if (response?.message != null && response?.message != '') {
                this.commonService.showNotificationMessage(response.message, 'warning', 'center', 200, false);
              } else {
                this.commonService.showNotificationMessage('Build updated with new EPL Change.', 'success', 'center', 200, false);
              }
              this.stepNavigateTo.emit('Build');
            }
          },
          error: (err: any) => {
            if (err?.message) {
              this.commonService.showNotificationMessage(err?.message, 'warning', 'center');
            }
          }
        });
      }
    } else {
      this.commonService.showNotificationMessage('Please select at least one entry', 'error', 'center');
    }
  }

  showEPLDetailsPopup: boolean = false;

  detailsInput: any = null;

  eplObseluteData: any[] = []
  deleteReplaceGridData: Array<{ id: number, item: number, qty: number, isNewlyAdded: boolean, itemerror: boolean, error: string | null | undefined,isBannerError : boolean }> = [];
  isOnEdit: boolean = false;
  selectedRowData: number = -1;
  tempRowData: number = -1;
  excelHeaders_EPL = ["tag", "EPL Short", "EPL Long", "Item"];
  showDeletePopup = false;
  showDeleteReplacePopup = false;
  showObselutePopup = false;
  showDetailsPopup = false;
  deleteSearchFound = false;
  validItemAdded = false;
  deleteTextBox = ""
  deleteTextboxValue = 0;

  prevItem = -1;
  prevQty = -1;

  eplRadiButtonShow = true;
  eplTagList: any[] = [];
  eplEplShortList: any[] = [];
  eplEplLongList: any[] = [];
  eplItemList: any[] = [];

  searchMWOList: any = []
  searchJobPlanNumberList: any = []
  searchMwoProblemDescriptionList: any = []
  prevEplSearchPayload = {}
  prevJobPlanSearchPayload = {}

  getEPLResults() {
    this.isSearchedByEplItem = (this.searchForm.value.item ?? "") != '' && (this.subSearchForm.value.isExactResultsOnly ?? false);
    this.showAddEplBtn = false;
    this.showUpdateEplBtn = false;
    this.eplRadiButtonShow = false;
    this.eplTagList = [];
    this.eplEplShortList = [];
    this.eplEplLongList = [];
    this.eplItemList = [];
    this.searchMWOList = []
    this.searchJobPlanNumberList = []
    this.searchMwoProblemDescriptionList = []
    let payload = this.trimPayload();
    payload.isExactResultsOnly = this.subSearchForm.controls["isExactResultsOnly"].value ?? false;
    this.prevEplSearchPayload = payload;
    this.eplService.getEplData(payload).subscribe((response) => {
      // Check if response has the Data property
      const data = response?.data || response;
      const validTagsCount = response?.validtagsCount;
      if (data?.length > 0) {

        this.eplRadiButtonShow = true;
        this.searchData = data;
        this.adjustGridHeight(this.searchData);
        this.isShowPagination = this.searchData.length > 300;
        this.showUpdateEplBtn = true;
        this.isSearchClicked = true;
        this.eplTagList = this.searchForm.controls['tag'].value.split(',').filter((data: any) => data);
        this.eplEplShortList = this.searchForm.controls['epl'].value.split(',').filter((data: any) => data);
        this.eplEplLongList = this.searchForm.controls['epL_Long'].value.split(',').filter((data: any) => data);
        this.eplItemList = this.searchForm.controls['item'].value.split(',').filter((data: any) => data);
        data.map((response: any) => {
          response.isTagSearchMatch = this.eplTagList.includes(response?.tag ?? "");
          response.isEplShortSearchMatch = this.eplEplShortList.includes(response?.epL_Short_PLITM ?? "");
          response.isEplLongSearchMatch = this.eplEplLongList.includes(response?.epL_Long_PLLITM ?? "");
          response.isItemMatch = this.eplItemList.includes(response?.item ?? "");
        });

        this.searchExportData = data.map((x: any) => {
          return {
            tag: x.tag,
            epL_Short_PLITM: x.epL_Short_PLITM,
            epL_Long_PLLITM: x.epL_Long_PLLITM,
            item: x.item
          }
        });
      } else {
        if (validTagsCount !== undefined && validTagsCount > 0) {
          const equipmentText = validTagsCount === 1 ? '1 equipment' : `${validTagsCount} equipment`;
          this.commonService.showNotificationMessage(`No Equipment Parts List maintained for ${equipmentText}. Click 'Add EPL' to proceed`, "info", 'center');
        }
        else {
          this.commonService.showNotificationMessage("No Equipment Parts List maintained for 1 equipment. Click 'Add EPL' to proceed", "info", 'center');
        }
        this.eplRadiButtonShow = false;
        this.showAddEplBtn = (this.searchForm.controls['tag'].value ?? "");
      }
    }, (error: any) => {
      const errorMessage = error?.message || error?.error || `${error}`;
      if (errorMessage.includes('Equipment does not exist in JDE')) {
        this.commonService.showNotificationMessage(errorMessage, 'warning', 'center');
        this.eplRadiButtonShow = false;
        this.showAddEplBtn = false;
      }
      else {
        this.commonService.showNotificationMessage(`${error}`, "info", 'center');
        this.eplRadiButtonShow = false;
        this.showAddEplBtn = (this.searchForm.controls['tag'].value ?? "");

      }

    });
  }

  detailsPopupOpen(dataitem: any) {
    this.showEPLDetailsPopup = true;
    this.detailsInput =
    {
      tag: dataitem.tag,
      epl: dataitem.epL_Short_PLITM,
      epL_Long: dataitem.epL_Long_PLLITM
    }
    this.eplService.getEplDetails(this.detailsInput).subscribe((data) => {
      this.gridPopupData = [];
      
      if (data?.length > 0) {
        data = data.map((response: any) => {
          response.ItemDesc = response.item_Desc01 + response.item_Desc02
          response.SubItemDesc = response.item_Sub_Dsc1 + response.item_Sub_Dsc2
          return response;
        });
        this.gridPopupData = data;
      }

      this.isGridPopupOpened = true;
    });
  }

  valueChangeDeleteTextbox(event: any) {
    this.deleteTextboxValue = event;
  }

  searchDeleteItem() {
    // reset old record
    this.isOnEdit = false;
    this.deleteReplaceGridData =[];
    this.selectedRowData = -1

    
    this.searchItem = this.deleteTextboxValue;
    this.deleteSearchFound = false;
    let payload = {
      CRId: this.crNo,
      item: this.deleteTextboxValue
    }
    this.eplService.searchValidItem(payload).subscribe((data) => {
      if (data.item2) {
        this.commonService.showNotificationMessage(data.item2, 'error', 'center', 200, true)
      } else {
        this.deleteSearchFound = data.item1[0].searchfound;
        this.deleteTextBox = data.item1[0].status;
      }
    })
  }

  openDeletePopup() {
    this.showDeletePopup = true;
  }

  checkMwoNumberExists(event: any) {
    let validateMWOExist = false;
    if ("shouldValidateMWOExist" in sessionStorage) {
      validateMWOExist = sessionStorage.getItem("shouldValidateMWOExist")?.toLocaleLowerCase() === "true";
    }

    if (validateMWOExist) {
      const validateMWOExistPayload = [...this.selectedIds].reduce((pre: any, next: any) => {
        if (this.searchData[next]?.mwoNumber) {
          pre.push(this.searchData[next]?.mwoNumber);
        }
        return pre;
      }, []);

      if (validateMWOExistPayload.length > 0) {

        this.pmService.checkMwoNumberExists(this.crNo, validateMWOExistPayload, true).subscribe({
          next: (response: any) => {
            if (response.length > 0) {
              let message = '';
              if (response.length == 1) {
                message = response.map((x: any) => ' MWO ' + x.mwoNumber + ' is already added to the CR </br>');

              } else {
                message = 'The following MWO are already added to the CR: ';
                message += response.map((x: any) => x.mwoNumber).join(', ');
              }
              this.commonService.showNotificationMessage(message, 'error', 'center', 200, true);
              this.selectedIds.clear();
              this.selectedIndexIds = [];
              // Check if the MWO number is already added to the CR              
              /*   response.forEach((x: any) => {
                   x.cridList = x.cridList.split(',');
                   let key  = 'CR' + this.crNo;
                   for(let i = 0; i < x.cridList.length; i++){
                    if(x.cridList[i] == key){
                        if(message == ''){
                            message = `MWO ${x.mwoNumber} is already added to the CR`;
                        }else{
                       // message += ` </br> MWO ${x.mwoNumber} is already added to the CR `;
                        message = 'The following MWO are already added to the CR: '; 
                        message +=  x.mwoNumber.join(', ');
                        }
                        break;
                    }
                   }
                });
              if (message && message.trim() !== '') {
                this.commonService.showNotificationMessage(message, 'error', 'center', 200, true);
                this.selectedIds.clear();
                this.selectedIndexIds = [];                
              }
              else {
                this.updateJobPlan(event);                
              } */
             
            } else {
              this.updateJobPlan(event);
            }
          },
          error: (err) => {
          }
        });
      } else {
        this.updateJobPlan(event);
      }
    } else {
      this.updateJobPlan(event);
    }
  }

  openReplacePopup() {
    this.showDeleteReplacePopup = true;
  }

  openObselutePopup() {
    this.popupShow = true;
    this.popupWidth = 800;
    this.popupHeight = 400;
    this.popupTitle = '';
  }

  deleteItem() {
    let getConfirm: boolean = confirm("Selected item will be deleted. Do you want to continue ?");
    if (getConfirm) {
      let payload = {
        crId: this.crNo,
        item: this.deleteTextboxValue
      }
      this.eplService.deleteObselute(payload).subscribe((data) => {
        if (data === "Success") {

          this.commonService.showNotificationMessage("Obsolete item deleted successfully", "success", "center")
          this.closePopup();

        }
      })
    }
  }

  undoObselute() {
    let ids: Array<number> = [];
    this.obseluteIds.forEach((index: any) => {
      ids.push(this.eplObseluteData[index]?.changeItemId ?? 0);
    });
    let reqdata = {
      crId: this.crNo,
      changeitemid: ids.join(',')
    };
    this.eplService.undoObselute(reqdata).subscribe((data) => {
      this.commonService.showNotificationMessage("Undo for " + this.obseluteIds.size + " item(s) successful.", "success", "center")
      this.closePopup();
    })
  }

  dataFormInitialize() {
    this.isOnEdit = false;
    this.prevItem = -1;
    this.prevQty = -1;

    this.selectedRowData = -1;
    this.tempRowData = -1;
  }

  addNewItem() {
    this.isOnEdit = true;
    this.selectedRowData = this.deleteReplaceGridData.length;
    this.tempRowData = this.selectedRowData;
    this.deleteReplaceGridData.push({ id: this.selectedRowData, 'item': 0, 'qty': 0, isNewlyAdded: true, itemerror: false, error: null,isBannerError : false });

  }

  onEditItem(index: any) {
    if (this.tempRowData === -1) {
      this.prevItem = this.deleteReplaceGridData[index]?.item ?? -1;
      this.prevQty = this.deleteReplaceGridData[index]?.qty ?? -1;
    }

    this.isOnEdit = true;
    this.selectedRowData = index;
    this.tempRowData = index;
  }

  getValidItemCount() {
    let errorCount = 0;

    if (this.deleteReplaceGridData.length === 0) {
      this.validItemAdded = false;
      return;
    }

    for (const row of this.deleteReplaceGridData) {
      const hasItemError = row.itemerror;
      const hasBannerError = row.isBannerError;
      const hasError = row.error == null ? false : true;
      const hasInvalidQty = row.qty <= 0;

      if (hasItemError || hasInvalidQty || hasBannerError || hasError) {
        errorCount++;
      }
    }

    this.validItemAdded = errorCount === 0;
  }

  submitItem(index: any) {

    this.deleteReplaceGridData = this.deleteReplaceGridData.map(row => ({
      ...row,
      isBannerError: false
    }));

    let data = this.deleteReplaceGridData[index];

    if (data.item > 0) {
      this.deleteReplaceGridData[index].isNewlyAdded = false;

      let payload = {
        CRId: this.crNo,
        item: data.item
      }
      data.itemerror = false;

      this.eplService.validateEplDetails(this.searchItem, data.item).subscribe((response) => {
        if (response?.status) {
          this.deleteReplaceGridData[index].error = null;
          if (response.bannerMsg)
            this.commonService.showNotificationMessage(response.bannerMsg, 'warning', 'center', 200, false);
          if (response?.bannerMsg || response?.gridMsg) {
            this.eplService.searchValidItem(payload).subscribe((response) => {
              data.itemerror = !(response.item1[0].searchfound);
              if (data.itemerror) {
                let errorMsg = 'Unknown Item ' + data.item;
                this.commonService.showNotificationMessage(errorMsg, 'error', 'center', 200, true);
                this.validItemAdded = false;
              } else {
                let errorCount = this.deleteReplaceGridData.filter((x: any) => x.itemerror).length;
                // this.deleteReplaceGridData.forEach((x:any)=>{
                //   if(x.itemerror){
                //     errorCount+=1;
                //   }
                // })
                if (errorCount == 0) {
                  this.validItemAdded = true;
                }
              }
            });
          }
        } else {
          if (response?.bannerMsg || response?.gridMsg) {
            if(response.gridMsg)
              this.deleteReplaceGridData[index].error = response.gridMsg;
            if (response.bannerMsg)
              this.commonService.showNotificationMessage(response.bannerMsg, 'error', 'center', 200, false)
          } 
        }
        this.checkDuplicateItem(data.item);
        
      });

      this.dataFormInitialize();
      this.getValidItemCount();
    }
  }

  checkDuplicateItem(item: any) {
    this.deleteReplaceGridData = this.deleteReplaceGridData.map(row => ({
      ...row,
      isBannerError: false
    }));
    let addedItems = this.deleteReplaceGridData.filter((x: any) => x.item);

    const norm = (v: any) => String(v).trim().toUpperCase();

    // Count occurrences
    const counts = new Map<string, number>();
    const originalByKey = new Map<string, string>(); // store original for message
    for (const r of addedItems) {
      const k = norm(r.item);
      counts.set(k, (counts.get(k) ?? 0) + 1);
      if (!originalByKey.has(k)) originalByKey.set(k, String(r.item));
    }

    // Find duplicates
    const dupKeys = [...counts.entries()]
      .filter(([, c]) => c > 1)
      .map(([k]) => k);

    // Build readable list for notification
    const dupReadable = dupKeys.map(k => originalByKey.get(k)!).filter(Boolean);

    // Show notification if duplicates exist
    if (dupReadable.length > 0) {
      let idx = 0;
      if (item == 0) {
        idx = this.deleteReplaceGridData.findIndex(x => Number(x.item) === Number(dupReadable[0]));
      } else {
        idx = this.deleteReplaceGridData.findIndex(x => Number(x.item) === Number(item));
      }
      if (idx !== -1) {
        (this.deleteReplaceGridData[idx] as any).isBannerError = true;
      }
      this.commonService.showNotificationMessage("Duplicate item number " + dupReadable[0], 'error', 'center', 200, false);
    }
    let errorCount = this.deleteReplaceGridData.filter((x: any) => x.error).length;
    this.validItemAdded = (errorCount == 0 && dupReadable.length == 0) ? true : false;
  }

  exitItem(index: number, id: number) {
    let data = this.deleteReplaceGridData[index];
    if (data?.isNewlyAdded) {
      this.deleteReplaceGridData.splice(index, 1);
    }
    else {
      this.deleteReplaceGridData[index].item = this.prevItem;
      this.deleteReplaceGridData[index].qty = this.prevQty;
    }
    
    this.checkDuplicateItem(data.item);
    this.initializePrevRecords();
    this.getValidItemCount();
  }

  deleteItemNumber(index: number) {
    const data = this.deleteReplaceGridData[index];
    if (index <= this.deleteReplaceGridData.length - 1) {
      this.deleteReplaceGridData.splice(index, 1);
    }
    this.checkDuplicateItem(data.item);
    this.initializePrevRecords();
    this.getValidItemCount();
  }

  initializePrevRecords() {
    this.prevItem = -1;
    this.prevQty = -1;
    this.isOnEdit = false;

    this.selectedRowData = -1;
    this.tempRowData = -1;
  }

  deleteAndReplace() {
    let getConfirm: boolean = confirm("Selected item will be deleted and replaced. Do you want to continue ?");
    if (getConfirm) {
      let items = this.deleteReplaceGridData.map((x: any) => x.item).join(",");
      let qts = this.deleteReplaceGridData.map((x: any) => x.qty).join(",");
      let payload = {
        crId: this.crNo,
        item: this.deleteTextboxValue,
        qty: qts,
        updateitemId: items
      }
      this.eplService.deleteReplaceObselute(payload).subscribe((data) => {
        if (data === "Success") {
          this.commonService.showNotificationMessage("Obsolete item deleted and replaced with new items successfully.", "success", "center");
          this.closePopup();
        }
      });
    }
  }


  public rowCallback = (context: RowClassArgs) => {
    if ((context.index + 1) % 2 == 0) {
      return { even: true };
    } else {
      return { odd: true };
    }
  };

  adjustGridHeight(data: any[]) {
    let recordCount = data.length;
    if (recordCount === 0) {
      this.gridHeight = 75;
    } else {
      this.gridHeight = (recordCount >= 8 ? 400 : 50 + (recordCount * 50));
    }
  }

  isDeleteReplaceEnabled(): boolean {
    return (
      this.deleteSearchFound &&
      this.validItemAdded &&
      this.deleteReplaceGridData.length > 0 &&
      this.deleteReplaceGridData.every(row => row.qty > 0)
    );
  }
}
